module.exports = __webpack_public_path__ + "static/media/scale-object.73bf6a0c.gif";